import type { ColDef } from 'ag-grid-enterprise';
import { getReferenceCellRenderer } from '../CellRenderers/cellRenderers';
import {
  mapReportColumnToAgGridColumnContext,
  mapReportColumnToAgGridFilter,
} from '../columns/mapReportColumnDefinitionToAgGridFormat';
import type { ColumnDefinitionArdoqMetadata } from '../types';
import type {
  ReferenceInventoryColumn,
  ReferenceInventoryRow,
  RequestedReferenceColumn,
} from './types';

export type ReferenceInventoryColDef = ColDef<ReferenceInventoryRow> & {
  context: ColumnDefinitionArdoqMetadata & {
    requestedColumn: RequestedReferenceColumn;
  };
};

const toColumnDef = (
  column: ReferenceInventoryColumn
): ReferenceInventoryColDef => {
  const { key, label, type, dataType, isVisible } = column;
  const { filter, filterParams } = mapReportColumnToAgGridFilter(column);
  return {
    colId: key,
    field: key,
    headerName: label,
    hide: !isVisible,
    sortable: false,
    filter,
    filterParams,
    cellRenderer: getReferenceCellRenderer(column),
    context: {
      ...mapReportColumnToAgGridColumnContext(column),
      requestedColumn: { key, label, type, dataType },
    },
  };
};

export const getReferenceInventoryColumnDefs = (
  columns: ReferenceInventoryColumn[]
): ReferenceInventoryColDef[] => columns.map(toColumnDef);
